class ReviewShowcase extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.mobileBreakpoint = 990;
    this.scrollContainer = null;
    this.prevButton = null;
    this.nextButton = null;
  }

  connectedCallback() {
    this.scrollContainer = this.querySelector('[data-scroll-container]');
    this.prevButton = this.querySelector('[data-scroll-prev]');
    this.nextButton = this.querySelector('[data-scroll-next]');

    this.init();
    this.bindEvents();
  }

  disconnectedCallback() {
    this.destroySwiper();
    window.removeEventListener('resize', this.handleResize);
  }

  init() {
    if (window.innerWidth < this.mobileBreakpoint) {
      this.initSwiper();
    }
    this.initDesktopScroll();
  }

  bindEvents() {
    this.handleResize = this.debounce(() => {
      if (window.innerWidth < this.mobileBreakpoint) {
        if (!this.swiper) {
          this.initSwiper();
        }
      } else {
        this.destroySwiper();
      }
      this.updateNavButtons();
    }, 150);

    window.addEventListener('resize', this.handleResize);

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.contains(this)) {
        this.init();
      }
    });
  }

  initSwiper() {
    if (typeof Swiper === 'undefined') return;

    const swiperElement = this.querySelector('.review-showcase__swiper');
    if (!swiperElement || this.swiper) return;

    const autoplay = this.dataset.autoplay === 'true';
    const speed = parseFloat(this.dataset.speed) || 4;

    this.swiper = new Swiper(swiperElement, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      centeredSlides: false,
      loop: false,
      pagination: {
        el: '.review-showcase__pagination',
        clickable: true,
      },
      autoplay: autoplay ? {
        delay: speed * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      } : false,
    });
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  initDesktopScroll() {
    if (!this.scrollContainer || !this.prevButton || !this.nextButton) return;

    const scrollAmount = 200;

    this.prevButton.addEventListener('click', () => {
      this.scrollContainer.scrollBy({
        top: -scrollAmount,
        behavior: 'smooth'
      });
    });

    this.nextButton.addEventListener('click', () => {
      this.scrollContainer.scrollBy({
        top: scrollAmount,
        behavior: 'smooth'
      });
    });

    this.scrollContainer.addEventListener('scroll', () => {
      this.updateNavButtons();
    });

    this.updateNavButtons();
  }

  updateNavButtons() {
    if (!this.scrollContainer || !this.prevButton || !this.nextButton) return;

    const { scrollTop, scrollHeight, clientHeight } = this.scrollContainer;
    const isAtTop = scrollTop <= 0;
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;

    this.prevButton.disabled = isAtTop;
    this.nextButton.disabled = isAtBottom;
  }

  debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
}

customElements.define('review-showcase', ReviewShowcase);
